import { useEffect } from "react";

const SITE = "https://zentryxsystems.com";
const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1758519288355-fe5b6fcc9f39?auto=format&fit=crop&q=80&w=1200";

// SEO helper: sets document title, meta description, canonical, and
// Open Graph / Twitter Card tags for rich sharing and better local SEO.
export const Seo = ({ title, description, path, image }) => {
  useEffect(() => {
    if (title) document.title = title;
    const url = path ? `${SITE}${path}` : SITE;
    const ogImage = image || DEFAULT_OG_IMAGE;

    const setTag = (selector, attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setTag('meta[name="description"]', "name", "description", description);

    // Open Graph
    setTag('meta[property="og:title"]', "property", "og:title", title);
    setTag('meta[property="og:description"]', "property", "og:description", description);
    setTag('meta[property="og:type"]', "property", "og:type", "website");
    setTag('meta[property="og:url"]', "property", "og:url", url);
    setTag('meta[property="og:image"]', "property", "og:image", ogImage);
    setTag('meta[property="og:site_name"]', "property", "og:site_name", "Zentryx Systems");

    // Twitter
    setTag('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    setTag('meta[name="twitter:title"]', "name", "twitter:title", title);
    setTag('meta[name="twitter:description"]', "name", "twitter:description", description);
    setTag('meta[name="twitter:image"]', "name", "twitter:image", ogImage);

    // Canonical
    if (path) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    }
  }, [title, description, path, image]);

  return null;
};
